








































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import BlurredTenant from "@/components/BlurredTenant.vue";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";

export default Vue.extend({
  components: { BlurredTenant },
  data() {
    const vm = this;
    const paymentMethodId = this.$route.query.paymentMethodId as string;
    return {
      paymentMethodId,
      showBlur:
        userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) &&
        !!userManager.getUserInfo().tenant?.setting?.expDate &&
        userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),

      tableContainer: new DataContainer(),

      addDialog: false,
      addLoading: false,
      addForm: {
        napasMerchantIdsText: "",
      },

      snackbar: {
        show: false,
        text: "",
        color: "success",
      },

      tableOptions: {
        attrs: {
          "item-key": "_id",
        },
        content: {
          name: "Napas Merchants",
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              napasMerchantId: {
                attrs: {
                  label: "Merchant ID",
                },
                rules: {
                  match: {},
                },
              },
            },
          },
          displayFields: {
            napasMerchantId: {
              text: "Merchant ID",
              sortable: true,
            },
            createdAt: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          topActionButtons: {
            add:
              userManager.checkRole([
                "systemAdmin",
                "admin",
                "cpoAdmin",
              ]) && {
                content: {
                  text: "Add Merchants",
                  icon: "mdi-plus",
                },
                on: {
                  xClick() {
                    vm.openAddDialog();
                  },
                },
              },
          },
          template: {
            itemActionButtons: {
              delete:
                userManager.checkRole([
                  "systemAdmin",
                  "admin",
                  "cpoAdmin",
                ]) && {
                  content: {
                    icon: "mdi-delete",
                    color: "error",
                    small: true,
                  },
                  target: {
                    tooltip: {
                      content: {
                        text: "Delete",
                      },
                    },
                    confirm: {
                      content: {
                        content: {
                          html: "Are you sure you want to delete this merchant? The merchant must be unassigned from any connector first.",
                        },
                      },
                      on: {
                        async xYes({ self }) {
                          const yesBtn = self.yesBtnContainer.value;
                          const btn = self.context();
                          const { dataTable, item } = btn.context();
                          yesBtn.loading.value = true;
                          const result = await dataTable.execute(
                            async () => {
                              return await coreApiClient.call(
                                "napasMerchants",
                                "removeMerchant",
                                { napasMerchantId: item.napasMerchantId }
                              );
                            },
                            undefined,
                            {
                              disableLoading: true,
                              willRefresh: true,
                            }
                          );
                          yesBtn.loading.value = false;
                          if (result) {
                            self.hide();
                          }
                        },
                      },
                    },
                  },
                },
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const payload = JSON.parse(options.payload || "{}");
              const filters = payload.filters || [];
              if (paymentMethodId) {
                filters.push({
                  key: "paymentMethodId",
                  operator: "equal_to",
                  value: paymentMethodId,
                });
              }
              const apiOptions = {
                ...options,
                payload: JSON.stringify({ ...payload, filters }),
              };
              try {
                const response = await coreApiClient.call(
                  "napasMerchants",
                  "findAll",
                  apiOptions
                );
                const items = response?.items || [];
                const count = response?.count ?? items.length;
                return [items, count];
              } catch (e) {
                const err = e as any;
                vm.showSnackbar(
                  err?.response?.data?.message ||
                    err?.message ||
                    "Failed to load merchants",
                  "error"
                );
                return [[], 0];
              }
            },
          },
        },
      },
    };
  },
  methods: {
    openAddDialog() {
      this.addForm = { napasMerchantIdsText: "" };
      this.addDialog = true;
    },
    closeAddDialog() {
      this.addDialog = false;
    },
    async submitAddMerchants() {
      const ids = this.addForm.napasMerchantIdsText
        .split("\n")
        .map((id) => id.trim())
        .filter((id) => id.length > 0);
      if (ids.length === 0) {
        this.showSnackbar("Please enter at least one Merchant ID", "error");
        return;
      }
      this.addLoading = true;
      try {
        await coreApiClient.call("napasMerchants", "addMerchants", undefined, {
          napasMerchantIds: ids,
          paymentMethodId: this.paymentMethodId,
        });
        this.showSnackbar(`Added ${ids.length} merchant(s) successfully`, "success");
        this.closeAddDialog();
        this.refreshTable();
      } catch (e) {
        this.showSnackbar(
          (e as any)?.response?.data?.message || "Failed to add merchants",
          "error"
        );
      } finally {
        this.addLoading = false;
      }
    },
    refreshTable() {
      const tc = (this as any).tableContainer;
      if (tc?.value?.refresh) {
        tc.value.refresh();
      }
    },
    showSnackbar(text: string, color: string) {
      this.snackbar = { show: true, text, color };
    },
  },
});
